import React from 'react';
import { View, Text, TouchableOpacity, StyleSheet, Platform } from 'react-native';
import { useAuth } from '../context/AuthContext';

/**
 * Persistent banner shown while an admin is viewing the app via a read-only
 * "login as" impersonation token. Makes the impersonated, read-only state
 * unmistakable and offers a one-tap exit (clears the token + returns to login).
 * Renders nothing in a normal session.
 */
export const ImpersonationBanner: React.FC = () => {
  const { impersonation, logout } = useAuth();
  if (!impersonation) return null;

  const who = impersonation.email
    ? `Просмотр от имени ${impersonation.email}`
    : 'Просмотр от имени пользователя';

  return (
    <View style={styles.banner}>
      <Text style={styles.text} numberOfLines={1}>
        👁️ {who} — только чтение
      </Text>
      <TouchableOpacity onPress={() => logout()} style={styles.button} accessibilityRole="button">
        <Text style={styles.buttonText}>Выйти</Text>
      </TouchableOpacity>
    </View>
  );
};

const styles = StyleSheet.create({
  banner: {
    // Pin to the very top across the whole app on web; static bar on native.
    ...(Platform.OS === 'web'
      ? ({ position: 'fixed', top: 0, left: 0, right: 0 } as any)
      : {}),
    zIndex: 9999,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#b45309',
    paddingVertical: 6,
    paddingHorizontal: 12,
    gap: 12,
  },
  text: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '600',
    flexShrink: 1,
  },
  button: {
    backgroundColor: 'rgba(255,255,255,0.2)',
    borderRadius: 6,
    paddingVertical: 3,
    paddingHorizontal: 10,
  },
  buttonText: {
    color: '#fff',
    fontSize: 13,
    fontWeight: '700',
  },
});

export default ImpersonationBanner;
